/**
 * AI 排查接口
 *
 * 排查一条 AI 回复背后的 LLM 调用链，给出归因与优化建议。
 * 算法端耗时可达分钟级，所以后端拆成「提交 + 轮询」两步：
 * submit 立即返回 trace_id，再拿它轮询 result 直到 status 不为 0。
 */
import { apiGet, apiPost } from '@/utils/request';
import type { AiDebugTraceResult, AiDebugTraceSubmitResult } from '@/types/aiTest';

export const aiDebugTraceApi = {
  /** 提交排查任务，同一条消息重复提交每次都会新建记录 */
  submit: (data: { message_id: number | string; call_type: string; question?: string }) =>
    apiPost<AiDebugTraceSubmitResult>('/ai-test/debug-trace', data),
  /** 轮询排查结果 */
  result: (traceId: number) =>
    apiGet<AiDebugTraceResult>('/ai-test/debug-trace/result', { trace_id: traceId }),
};
